import  { useDispatch, useSelector } from 'react-redux'
import { useUrlFilters } from '@/hooks/useUrlFilters'
import { Badge, FilterButton, Pagination, SectionPanel, Spinner } from '@/components/ui'

import { fetchDocuments, setFilters, documentFilters, ordonnedDocumentFilters } from './documentsSlice'
import DocumentItem from './DocumentItem'
import FormNew from './form/FormNew'
import DocumentSearch from './DocumentSearch'

export default () => {
  const dispatch = useDispatch()
  const documents = useSelector( state => state.documents.items)
  const filters = useSelector( state => state.documents.filters)
  const pagination = useSelector((state) => state.documents.pagination)
  const isLoading = useSelector((state) => state.documents.loadingStatus.fetchList)

  const SECTION_TITLE = 'Détails des documents'

  useUrlFilters({
    setFiltersAction: setFilters,
    fetchAction: fetchDocuments,
    filters,
    allowedParams: ['type_document', 'page', 'limit']
  })

  const handlePageChange = (page) => {
    dispatch(setFilters({page}))
  }

  const handleFiltersChange = (newFilters) => {
    const filterUpdates = { page: 1 }
    if('type_document' in newFilters) {
      filterUpdates.type_document = newFilters.type_document
    } else {
      filterUpdates.type_document = undefined
    }
    dispatch(setFilters(filterUpdates))
  }

  const getFilterBadgeText = (filterKey) => {
    const value = filters[filterKey]
    if(!value) return null;
    if(filterKey === 'term') {
      return `recherche : ${value}`
    }
    return documentFilters[value] ? 
      documentFilters[value].label.toLowerCase() : 
      null
  }

  return (
    <>
      <FormNew />
      <SectionPanel>
        <SectionPanel.Title className='font-normal'>
          <div>
            <h2 className="text-xl font-semibold mb-2">
              {SECTION_TITLE}
            </h2>
            <div>
              { ['type_document', 'term'].map( (filterKey, index) => (
                getFilterBadgeText(filterKey) && 
                  <Badge key={index} text={getFilterBadgeText(filterKey)} className='mr-2'/>
              ))}
            </div>
          </div>
          
          <div className="flex items-right justify-between items-center mb-4">
            <div className="dropdown">
              <FilterButton 
                filters={ordonnedDocumentFilters(filters)} 
                onChange={handleFiltersChange}
              />
            </div>
            
            <div>
              <DocumentSearch />
            </div>
          </div>
        </SectionPanel.Title>
        <SectionPanel.Body columns={1} bgColor='white' className='p-0'>
          <div>
            <table className="table table-zebra w-full">
              <thead>
                <tr>
                  <th>Titre</th>
                  <th>Type de doc</th>
                  <th>Bien lié</th>
                  <th>Contacts liés</th>
                  <th>Date dispo.</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {isLoading && <tr><td colSpan="5"><Spinner color='primary'/></td></tr>}
                {!isLoading && documents.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-center py-4 text-gray-600 italic">
                      Aucun document trouvé
                    </td>
                  </tr>
                )}
                { !isLoading && documents.length > 0 && documents.map(
                  (document, index) => (
                    <DocumentItem item={document} key={index} />
                  )
                )}
              </tbody>
            </table>
          </div>
          {pagination.totalPages > 1 && (
            <Pagination 
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </SectionPanel.Body>
      </SectionPanel>
    </>
  )
}